import React, { useContext } from 'react';
import { VscArrowRight } from "react-icons/vsc";
import { LanguageContext } from "../languages/LanguageContext";
import { HiArrowLongRight } from "react-icons/hi2";

const Hero = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <div className='hero-container max-w wrap'>
            <div className='hero-content flex col gap-1 jc-c'>
                <h2 dangerouslySetInnerHTML={{ __html: translations[language]["heroTitle"] }}></h2>
                <div className='points flex col gap-sm w-full'>
                    <div className='flex ai-c gap-1'>
                        <div className='point'>
                            <VscArrowRight className='icon'/>
                        </div>
                        <span>{translations[language]["education"]}</span>
                    </div>
                    <div className='flex ai-c gap-1'>
                        <div className='point'>
                            <VscArrowRight className='icon'/>
                        </div>
                        <span>{translations[language]["consulting"]}</span>
                    </div>
                    <div className='flex ai-c gap-1'>
                        <div className='point'>
                            <VscArrowRight className='icon'/>
                        </div>
                        <span>{translations[language]["recruiting"]}</span>
                    </div>
                </div>
                <div className='flex'>
                    <button onClick={() => window.location.href = '#quote'}>
                        {translations[language]["learnMore"]}
                        <HiArrowLongRight className='icon-btn'/>
                    </button>
                </div>
            </div>
            <div className='hero-art flex col'>
                <img className='hero-image-1' src='/images/landing/hero-image-1.jpg' alt='hero'/>
                <img className='hero-image-2' src='/images/landing/hero-image-2.jpg' alt='hero'/>
            </div>
        </div>
    );
};

export default Hero;